import React from "react";
import Sales from "./Sales";
import CashCancellationsCourtesy from "./CashCancellationsCourtesy";
import Reservations from "./Reservations";
import StatsDay from "../../../../../../../interfaces/StatsDay";

const FullWidthHalfHeight: React.FC<{ day: StatsDay, isFutureDate: boolean; }> = ({ day, isFutureDate }) => {
  return (
    <>
      {
        isFutureDate ?
          <Reservations day={day} />
          :
          <>
            <Sales day={day} />
            <CashCancellationsCourtesy day={day} />
            <Reservations day={day} />
          </>
      }
    </>
  );
};

export default FullWidthHalfHeight;
